<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">English Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <ValidationProvider
            vid="question"
            rules="required"
            name="The Question"
            v-slot="{ passed, failed,errors }">
            <fg-input type="text"
                      :error="failed ? errors[0]: null"
                      label="Question"
                      name="question"
                      fou
                      @keyup="generateSomeFields"
                      v-model="formData.question">
            </fg-input>
          </ValidationProvider>
          <ValidationProvider
            vid="url"
            rules="required"
            name="The URL"
            v-slot="{ passed, failed,errors }">
            <fg-input type="text"
                      :error="failed ? errors[0]: null"
                      label="URL"
                      name="url"
                      fou
                      v-model="formData.url">
            </fg-input>
          </ValidationProvider>
          <ValidationProvider
            vid="answer"
            rules="required"
            name="The Answer"
            v-slot="{ passed, failed,errors }">
            <fg-text type="text"
                     :error="failed ? errors[0]: null"
                     label="Answer"
                     name="answer"
                     fou
                     v-model="formData.answer">
            </fg-text>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group pt-4">
        <label>Is Active</label>&nbsp;
        <l-switch v-model="formData.is_active">
          <i class="fa fa-check" slot="on"></i>
          <i class="fa fa-times" slot="off"></i>
        </l-switch>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { extend } from "vee-validate";
  import { required, email } from "vee-validate/dist/rules";
  import {Option, Select, Tooltip} from "element-ui";
  import FgSelect from "@/components/Inputs/formGroupSelect";
  import FormGroupTextArea, {ImageUploader, PrimeUploader, PrimeVideoUploader, Switch as LSwitch} from "@/components";
  import Editor from '@tinymce/tinymce-vue'

  extend("required", required);
  extend("email", email);

  export default {
    components: {
      FormGroupTextArea,
      [Option.name]: Option,
      [Select.name]: Select,
      [Tooltip.name]: Tooltip,
      FgSelect,
      LSwitch,
      PrimeUploader,
      ImageUploader,
      PrimeVideoUploader,
      'editor': Editor
    },
    props: {
      lang: {
        type: String,
        default: 'en'
      },
      editMode: {
        type: Boolean,
        default: false
      },
      formData:{
        type: Object,
        default() {
          return {
            question: "",
            answer :"",
            url :"",
            is_active: true,
          }
        }
      },
    },
    data() {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      };
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      generateSomeFields() {
        if(this.editMode){
          return;
        }
        let newUrl = '';
        if (this.formData.question) {
          newUrl = this.formData.question.replace(/\s+/g, "-").toLowerCase();
          newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
          newUrl = newUrl.replace(/([-]+)/g, "_");
        }

        this.formData.url = newUrl;
      },
    }
  }
</script>
<style>
</style>
